import { NgModule, ModuleWithProviders } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import { CandidatoLogadoGuard } from './candidatoLogadoGuard.guard';

@NgModule({
  imports: [
    SharedModule,
  ],
})
export class PSSAuthenticationModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: PSSAuthenticationModule,
      providers: [
        CandidatoLogadoGuard,
      ]
    };
  }
}


// WEBPACK FOOTER //
// ./src/app/authentication/authentication.module.ts